import { lazy } from 'react';

const MerchantOffersCompare = lazy(() => import('./MerchantOffersComparePage'));

const MerchantOffersCompareConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'merchant/offers/compare',
      element: <MerchantOffersCompare />,
    },
  ],
};

export default MerchantOffersCompareConfig;
